import { withStyles } from 'tss-react/mui';
import { Typography, Card, CardActions, CardContent, Button, Grid } from '@mui/material';

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadUserProfile } from '../../store/actions/userProfileActions';
import { getUserProfile, getIsPairedWithCinvio } from '../../store/selectors/selectors';
import { pairPaymentOption } from '../../store/actions/userProfileActions';
import { EXTERNALPRODUCTPAGE } from '../../config/environment';
import { FORMATTING, LABEL, TEXT } from '../../theme/constants';
import { useNavigate } from 'react-router-dom';

const styles = () => ({
  root: {
    display: 'flex',
    marginTop: '10%',
  },
  rootForbidden: {
    position: 'fixed',
    top: '10%',
    left: '45%',
    fontSize: '20px',
  },
  buttonConfirm: {
    margin: 'auto',
    backgroundColor: '#009dfe',
  },
  titleConfirm: {
    textAlign: 'center',
  },
});

const PairedRedirect = (props) => {
  const { classes, userProfile, pairPaymentOption, isPairedWithCinvio } = props;
  const navigate = useNavigate();

  const handlePairButtonClick = (e) => {
    e.stopPropagation();
    pairPaymentOption();
  };

  useEffect(() => {
    if (isPairedWithCinvio) {
      window.open(EXTERNALPRODUCTPAGE, '_blank');
      navigate('/');
    }
  }, [isPairedWithCinvio]);

  const nxtEntityId = props.match.params.id;

  let canAccess = userProfile.nxtEntityId === nxtEntityId;

  if (!canAccess) {
    return (
      <>
        <div className={classes.rootForbidden}>Forbidden</div>
      </>
    );
  }
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={0} justifyContent="center" direction="column" alignItems="center">
          <Grid size={{ md: 4 }}>
            <Card className={classes.cardBlock}>
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="h2"
                  className={classes.titleConfirm}
                >
                  {LABEL.PAIR_CINVIO_TITLE}
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  {TEXT.PAIR_PAGE.replace(
                    FORMATTING.USERPROFILE_FULLNAME,
                    userProfile.firstName + ' ' + userProfile.lastName
                  )}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  className={classes.buttonConfirm}
                  variant="contained"
                  color="primary"
                  onClick={(e) => handlePairButtonClick(e)}
                >
                  {LABEL.CONFIRM}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

PairedRedirect.propTypes = {
  classes: PropTypes.object,
  userProfile: PropTypes.object,
  selectedUserType: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    userProfile: getUserProfile(state),
    isPairedWithCinvio: getIsPairedWithCinvio(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadUserProfile,
      pairPaymentOption,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PairedRedirect, styles));
